import { useRouteBodyState } from "@-/dev.improve.haniverse.lib.navigation.route-body-state";
import type { MorphemeInfoPanelAccordionSectionDescriptor } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content._components.morpheme-info-panel-accordion";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { View } from "@-/com.npmjs.react-native";

export function useMorphemeInfoPanelLearningProgressWordStatsSection(): MorphemeInfoPanelAccordionSectionDescriptor {
  const [isOpen, setIsOpen] = useRouteBodyState(
    "use-morpheme-info-panel-learning-progress-word-stats-section.tsx:isOpen",
    true,
  );

  return {
    bodyKey: "morpheme-info-learning-progress-word-stats-body",
    headerKey: "morpheme-info-learning-progress-word-stats-header",
    iconName: "LuLibrary",
    isOpen,
    onToggle: () => setIsOpen((previousState) => !previousState),
    renderBody: () => (
      <View className="px-4 pt-2 pb-4">
        <Text className="text-base text-muted-foreground italic">
          Word-level learning progress is coming soon.
        </Text>
      </View>
    ),
    title: "Progress",
  };
}
